<template>
  <div>
    <!-- <GlobalTable
      :title="title+' List'"
      :fields="fields"
      :items="items"
      :editButton="true"
      :redirectDetail="true"
      :isLoading="isLoading"
      @addForm="addForm"
      @editForm="editForm"
    ></GlobalTable> -->

    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <CIcon name="cil-grid" />
              {{ title }}
            </slot>
          </CCardHeader>

          <CCardBody>
            <template v-if="!isLoading">
              <TableButton
                :visibilityShow="visibilityShow"
                :showNeed="showNeed"
                :exportNeed="exportNeed"
                :title="title"
                @addForm="addForm"
                @myListBoxOnCheckChange="myListBoxOnCheckChange($event)"
              ></TableButton>

              <CRow>
                <CCol sm="12">
                  <JqxGrid
                    v-if="items"
                    ref="myGrid"
                    :width="'100%'"
                    :source="items"
                    :columns="fields"
                    :columnsresize="true"
                    :sortable="true"
                    :pageable="true"
                    :autoheight="true"
                    :showfilterrow="true"
                    :filterable="true"
                    :localization="localization"
                    :selectionmode="''"
                  >
                  </JqxGrid>
                </CCol>
              </CRow>
            </template>
            <Loading v-else></Loading>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{ title }}</h6>
      </template>

      <CForm>
        <CRow>
          <CCol sm="3">
            <CInput
              label="Name"
              invalid-feedback="name should be filled"
              required
              v-model="$v.productCategoryForm.name.$model"
              :is-valid="!$v.productCategoryForm.name.$invalid"
            />
          </CCol>
          <CCol sm="3">
            <div class="form-group">
              <label for="group">Group</label>
              <model-select
                class="form-control"
                id="group"
                :options="groupList"
                v-model="$v.productCategoryForm.group.$model"
                :isError="$v.productCategoryForm.group.$invalid"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div
                v-if="$v.productCategoryForm.group.$invalid"
                class="invalid-feedback-custom"
              >
                Group should be filled.
              </div>
            </div>
          </CCol>
          <!-- <CCol sm="3">
              <div class="form-group">
                <label for="parent">Parent</label>
                <model-select
                  class="form-control"
                  id="parent"
                  :options="categoryList"
                  v-model="$v.productCategoryForm.parent.$model"
                  :isError="$v.productCategoryForm.parent.$invalid"
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
                <div
                  v-if="$v.productCategoryForm.parent.$invalid"
                  class="invalid-feedback-custom"
                >Parent should be filled.</div>
              </div>
            </CCol>
         -->
          <CCol sm="3">
            <label>Installment</label><br />
            <CInputRadioGroup
              class="col-sm-9"
              :options="options"
              :custom="true"
              :checked="productCategoryForm.flag"
              :inline="true"
              @update:checked="(option) => (productCategoryForm.flag = option)"
            />
            <div
              v-if="$v.productCategoryForm.flag.$invalid"
              class="invalid-feedback-custom"
            >
              Installment condition should be filled.
            </div>
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="8">
            <!-- <label for="nik">Description</label>
              <quill-editor style="height: 200px; margin-bottom:70px;"
                :content="content"
                :options="editorOption"
                v-model="$v.productCategoryForm.description.$model"
                @change="onEditorChange($event)">
              </quill-editor> -->
            <!-- <div v-if="$v.productCategoryForm.description.$invalid" class="invalid-feedback-custom">
                Description harus di isi.
              </div> -->
            <CTextarea
              rows="4"
              label="Description"
              invalid-feedback="Description should be filled"
              required
              v-model="$v.productCategoryForm.description.$model"
              :is-valid="!$v.productCategoryForm.description.$invalid"
            />
          </CCol>
        </CRow>
      </CForm>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton
          @click="submitForm"
          :disabled="$v.productCategoryForm.$invalid"
          color="success"
        >
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
// import GlobalTable from "../../../templates/Table";
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";

import Loading from "@/templates/Loading.vue";
import TableButton from "@/templates/TableButton";
import JqxGrid from "jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import Quill from "quill";

export default {
  name: "ProductCategory",
  components: { quillEditor, Loading, TableButton, JqxGrid },
  data() {
    return {
      title: "Product Category",
      categoryList: [],
      groupList: [],
      source: {
        localdata: [],
        datafields: [
          { name: "id", type: "number" },
          { name: "name", type: "string" },
          { name: "group_name", type: "string" },
          { name: "installment_name", type: "string" },
          { name: "description", type: "string" },
        ],
        datatype: "json",
      },
      editrow: -1,

      fields: [
        {
          datafield: "name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Name",
        },
        {
          datafield: "group_name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Group",
        },
        {
          datafield: "installment_name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Installment",
        },
        {
          datafield: "description",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Description",
        },
        {
          text: "Action",
          align: "center",
          name: "EditAction",
          columntype: "button",
          width: 60,
          sortable: false,
          filtertype: "none",
          menu: false,
          cellsrenderer: () => {
            return "Edit";
          },
          buttonclick: (row) => {
            let dataRecord = this.$refs.myGrid.getrowdata(row);
            let path = this.$route.path.split("/");

            this.$router.push({
              path: path.hasOwnProperty("2")
                ? path[2] + "/detail/" + dataRecord.id
                : "detail/" + dataRecord.id,
            });
          },
        },
      ],

      items: null,
      productCategoryForm: tableInterfaces.product_category,
      isLoading: false,
      addButton: false,
      isEdit: false,
      options: [
        { value: "1", label: "Yes" },
        { value: "0", label: "No" },
      ],
      content: "",
      editorOption: {}, // data quill

      visibilityShow: false,
      showNeed: false,
      exportNeed: false,
      localization: getLocalization("en"),
      visibilityShow: false,
    };
  },
  validations: {
    productCategoryForm: {
      name: { required },
      parent: {},
      group: { required },
      flag: { required },
      description: { required },
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    //NewTable Function --start
    exportXls: function () {
      this.$refs.myGrid.exportdata("xls", "order");
    },
    exportPdf: function () {
      this.$refs.myGrid.exportdata("pdf", "order");
    },
    myListBoxOnCheckChange: function (event) {
      this.$refs.myGrid.beginupdate();
      if (event.args.checked) {
        this.$refs.myGrid.showcolumn(event.args.value);
      } else {
        this.$refs.myGrid.hidecolumn(event.args.value);
      }
      this.$refs.myGrid.endupdate();
    },
    showHide: function () {
      this.visibilityShow = !this.visibilityShow;
    },
    // NewTable Function --end
    init: function () {
      this.isEdit = false;
      this.cancelForm();
      this.getCategory();
      this.getDropdown();
    },
    getDropdown: function () {
      this.axios.get("/console/master/product_category/dropdown").then((response) => {
        this.categoryList = response.data.category;
        this.groupList = response.data.group;
      });
    },
    getCategory: function () {
      this.isLoading = true;
      this.axios
        .get("console/master/product_category/listing")
        .then((response) => {
          if (response.data.status === 2000) {
            //this.items = response.data.data;
            const temp = this.source;
            temp.localdata = response.data.data;
            this.items = new jqx.dataAdapter(temp);

            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    addForm: function () {
      this.addButton = true;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function (item) {
      this.addForm();
      this.isEdit = true;
      this.productCategoryForm = item;
    },
    resetForm: function () {
      for (var i in tableInterfaces.product_category) {
        tableInterfaces.product_category[i] = null;
      }
      this.productCategoryForm = tableInterfaces.product_category;
    },
    submitForm: function (event) {
      event.preventDefault();
      if (this.isEdit === false) {
        if (confirm("Do you want to add this data ?")) {
          let path = this.$route.path.split("/");
          this.isLoading = true;
          this.axios
            .post("console/master/product_category/add", this.productCategoryForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        }
      } else {
        if (confirm("Do you want to change this data ?")) {
          this.isLoading = true;
          this.axios
            .put("console/master/product_category/update", this.productCategoryForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        }
      }
    },
    onEditorChange({ quill, html, text }) {
      this.content = html;
      this.productCategoryForm.description = html;
    },
  },
  mounted() {
    this.init();
  },
};
</script>
